import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import Navigation from '../components/Template/Navigation';
import Footer from '../components/Template/Footer';


const Main = (props) => (
  
  <HelmetProvider>
    <Helmet titleTemplate="%s" defer={false}>
      {props.title && <title>{props.title}</title>}
      <meta name="description" content={props.description} />
      <link rel="canonical" content={props.canonical} />
    </Helmet>
    <div id="wrapper">
      <Navigation />
      <div id="main">
        {props.children}
      </div>      
      <Footer />
    </div>
  </HelmetProvider>
);

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullPage: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
};

Main.defaultProps = {
  children: null,
  fullPage: false,
  title: null,
  description: "Vishal Bavadiya's personal website.",
};

export default Main;
